export const fmtClock = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", timeZone: "America/New_York" }); }
  catch { return ""; }
};

export const fmtHours = (h) => {
  const mins = Math.round((Number(h) || 0) * 60);
  return `${Math.floor(mins / 60)}h ${String(mins % 60).padStart(2, "0")}m`;
};

export const fmtDay = (isoDate) => {
  const [y, m, d] = isoDate.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
};

export const empStatus = (e) => {
  if (e.state === "on_break") return "on_break";
  if (e.state === "clocked_in") return "clocked_in";
  if (e.is_late) return "late";
  return "out";
};
